import { useMutation } from "@tanstack/react-query";
import { useClient } from "../context/auth-context";
import { generateMetaData } from "../util";
import { useIpDetails } from "./location-service";
import { fetchServiceJson } from "./service-fetch";

export function useCirclePlugLogin({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();
  return useMutation(
    (params) =>
      client("access/auth", {
        data: {
          ...params,
          accessLevel: "regular",
          ...generateMetaData(data),
        },
      }),
    {
      ...config,
    },
  );
}

export function useCirclePlugSignUp({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();
  return useMutation(
    (params) =>
      client("access/create", {
        data: {
          ...params,
          createType: "user",
          ...generateMetaData(data),
        },
      }),
    {
      ...config,
    },
  );
}

export function useAccessToken({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();
  return useMutation(
    (params) =>
      client("access/token", {
        data: {
          ...params,
          ...generateMetaData(data),
        },
      }),
    {
      ...config,
    },
  );
}

export function useVerifyOtp({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();
  return useMutation(
    (params) =>
      client("access/otp/verify", {
        data: {
          ...params,
          ...generateMetaData(data),
        },
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      }),
    {
      ...config,
    },
  );
}

export function useInitOtp({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();

  return useMutation(
    (params) =>
      client("access/otp/init", {
        data: {
          ...params,
          ...generateMetaData(data),
        },
        ...(params.token && {
          headers: {
            Authorization: `Bearer ${params.token}`,
          },
        }),
      }),
    {
      ...config,
    },
  );
}

export function useResetPassword({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();
  return useMutation(
    (params) =>
      client("access/password/change", {
        data: {
          ...params,
          type: "single",
          ...generateMetaData(data),
        },
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      }),
    {
      ...config,
    },
  );
}

export async function verifyPassword(token, userId, formData, ipDetails) {
  try {
    return await fetchServiceJson(
      `access/user/${userId}/password/verify`,
      token,
      {
        method: "POST",
        data: {
          ...formData,
          ...generateMetaData(ipDetails),
        },
        rejectOnError: true,
      },
    );
  } catch (error) {
    console.error("Error verifying password:", error);
    throw new Error(error?.message || "Unable to verify password");
  }
}

export async function updatePassword(token, userId, formData, ipDetails) {
  try {
    return await fetchServiceJson(`access/user/${userId}/password`, token, {
      method: "POST",
      data: {
        ...formData,
        ...generateMetaData(ipDetails),
      },
      rejectOnError: true,
    });
  } catch (error) {
    console.error("Error updating password:", error);
    throw new Error(error?.message || "Unable to update password");
  }
}
